import dayjs from 'dayjs';

import {
  clear as clearAppointments,
  listRequest as listAppointmentsRequest,
} from 'FRONTEND/reducers/appointmentSlice';
import {
  clear as clearAvailabilities,
  edit as editAvailability,
  listRequest as listAvailabilitiesRequest,
  selectAvailabilityById,
  stopEditing as stopEditingAvailability,
} from 'FRONTEND/reducers/availabilitySlice';
import { goToActorCalendar, mounted, updateCurrentDay } from 'FRONTEND/reducers/calendarSlice';
import { check, unCheck } from 'FRONTEND/reducers/expertSlice';
import { listLocations } from 'FRONTEND/reducers/locationSlice';
import { listResources } from 'FRONTEND/reducers/resourceSlice';
import { EXPERT } from 'FRONTEND/utils/constants';
import { RIGHTS } from 'FRONTEND/utils/rights';

const calendarMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case mounted.toString():
    case goToActorCalendar.toString():
    case updateCurrentDay.toString(): {
      next(action);
      const state = store.getState();
      const { actorId, actorType, currentDay } = state.calendar;
      const { checkedList, managedIdList } = state.expert;
      const expertList = managedIdList.length > 0 && checkedList.length === 0 ? managedIdList : checkedList;
      const { rights } = state.user;
      const hasServicesRights = rights.includes(RIGHTS.SERVICES_LIST);
      const hasLocationsRights = rights.includes(RIGHTS.LOCATIONS_LIST);
      const startDate = dayjs(currentDay).startOf('week').toString();
      const endDate = dayjs(currentDay).endOf('week').toString();

      let payloads = [];

      if (actorId) {
        payloads.push({ startDate, endDate, actorId, actorType });
      } else {
        payloads = expertList.map((id) => ({ startDate, endDate, actorId: id, actorType: EXPERT }));
      }

      payloads.forEach((payload) => {
        store.dispatch(listAvailabilitiesRequest(payload));
        store.dispatch(listAppointmentsRequest(payload));
      });

      if (hasServicesRights) {
        store.dispatch(listResources());
      }
      if (hasLocationsRights) {
        store.dispatch(listLocations());
      }
      return;
    }

    case editAvailability.toString(): {
      const currentDay = dayjs(store.getState().calendar.currentDay);
      const date = dayjs(action.payload.startDate);
      if (date.isBefore(currentDay.startOf('week')) || date.isAfter(currentDay.endOf('week'))) {
        store.dispatch(updateCurrentDay({ currentDay: date.toISOString() }));
      }
      return next(action);
    }

    case stopEditingAvailability.toString(): {
      next(action);
      if (action.payload.shouldRestore) {
        // There was no update, we need to go back to the original day in the calendar
        const availability = selectAvailabilityById(store.getState(), action.payload.id);
        store.dispatch(updateCurrentDay({ currentDay: availability.startDate }));
      }
      return;
    }

    case check.toString(): {
      const currentDay = store.getState().calendar.currentDay;
      const payload = {
        startDate: dayjs(currentDay).startOf('week').toString(),
        endDate: dayjs(currentDay).endOf('week').toString(),
        actorId: action.payload.id,
        actorType: EXPERT,
      };
      store.dispatch(listAppointmentsRequest(payload));
      store.dispatch(listAvailabilitiesRequest(payload));
      return next(action);
    }

    case unCheck.toString(): {
      store.dispatch(clearAppointments({ actorId: action.payload.id }));
      store.dispatch(clearAvailabilities({ actorId: action.payload.id }));
      return next(action);
    }

    default:
      return next(action);
  }
};

export default calendarMiddleware;
